const menuActionsTypes = {
    ADD_ITEMS_TO_MENU: 'ADD_ITEMS_TO_MENU',
    ADD_ITEM_TO_MENU: 'ADD_ITEM_TO_MENU',
    FILTER_MENU: 'FILTER_MENU'
};

export default menuActionsTypes;